import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { isPhone } from '@helpers';

import TouchableElement from '@components/common/touchableElement';
import LineButton from '@components/common/lineButton';

import { font } from '@styles/fonts';
import { getBoxShadowStyle } from '@styles/shadow';
import Svg from '@styles/icons/svg';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

export default ({ data, updateData, updateDataObj, C, setMode, MODES, goBack, validateUserAction }) => {
  const selectType = async (v) => {
    const isAuto = v.code === 'automatic';

    if (isAuto) {
      await validateUserAction({
        ...data,
        automaticControl: true,
      });
    } else {
      updateData('automaticControl', false);
      setMode(MODES.MACHINE_CONTROL);
    }
  };

  const typeList = [
    {
      name: 'Automatic',
      code: 'automatic',
    },
    {
      name: 'Manual',
      code: 'manual',
    },
  ];

  return (
    <View style={{ paddingBottom: scale(20), paddingHorizontal: isPhone ? 0 : scale(15) }}>
      <View>
        <View
          style={{
            width: '100%',
            zIndex: 1000,
            height: scale(58),
          }}
        >
          <View style={{ position: 'absolute', zIndex: 1000, left: 0 }}>
            <TouchableElement
              onPress={() => {
                updateDataObj({
                  automaticControl: false,
                });
                goBack();
              }}
            >
              {({ boxStyle, pressHoverColor }) => (
                <View style={[boxStyle, { padding: scale(15), paddingHorizontal: isPhone ? scale(15) : 0, flexDirection: 'row' }]}>
                  <View style={{ marginTop: scale(2) }}>
                    <Svg icon="chevronLeft" width={scale(11)} height={scale(17)} color="Link / Light / Primary" />
                  </View>
                  <Text style={[{ color: C(pressHoverColor('System/Light/Blue')), marginLeft: scale(7) }, font.Body]}>{i18n.t('Back')}</Text>
                </View>
              )}
            </TouchableElement>
          </View>
        </View>
        <View style={{ width: '100%', position: 'absolute', zIndex: 100, top: scale(15) }}>
          <Text style={[{ color: C('Label/Light/Primary'), width: '100%', textAlign: 'center' }, font.Headline]}>{i18n.t('Machine Control')}</Text>
        </View>
      </View>
      <View style={{ marginTop: scale(20), paddingHorizontal: scale(15) }}>
        <Text style={[{ color: C('Label/Light/Tertiary') }, font.Footnote]}>{i18n.t('SELECT MACHINE CONTROL')}</Text>
      </View>
      <View
        style={[
          getBoxShadowStyle({ type: 'Field', C }),
          { marginTop: scale(5), borderRadius: scale(SCREEN_BORDER_RADIUS) },
          isPhone && {
            borderColor: C('Hairline/Light/No trans'),
            borderBottomWidth: StyleSheet.hairlineWidth,
            borderTopWidth: StyleSheet.hairlineWidth,
          },
        ]}
      >
        {typeList.map((item, index) => (
          <LineButton
            key={item.code}
            {...{
              C,
              onPress: () => selectType(item),
              text: item.name,
              color: 'Link/Light/Primary',
              borderRadiusTop: isPhone ? false : index === 0,
              borderRadiusBottom: isPhone ? false : index === typeList.length - 1,
              shadow: false,
              borderBottom: index !== typeList.length - 1,
            }}
          />
        ))}
      </View>
    </View>
  );
};
